import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AccessGate from './components/AccessGate';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AccessGate>
      <App />
    </AccessGate>
  </React.StrictMode>
);